export const DEFAULT_GROUP_PICTURE =
  "https://res.cloudinary.com/duxrswftp/image/upload/v1717170899/chatbot/group_pic_ucwt71.png";

export const DEFAULT_USER_PICTURE =
  "https://res.cloudinary.com/duxrswftp/image/upload/v1717170948/chatbot/5907_cqgwyh_hjepl1.jpg";
